import { contact } from '../../data/siteContent';

function BottomBar() {
  return (
    <nav className="bottom-bar" aria-label="빠른 상담">
      <a className="call" href={`tel:${contact.phone}`}>전화</a>
      <a className="kakao" href={contact.kakao} target="_blank" rel="noreferrer">카톡</a>
      <a className="instagram" href={contact.instagram} target="_blank" rel="noreferrer">인스타</a>
    </nav>
  );
}

export default BottomBar;
